import { unityContext } from "components/UnityComponent/UnityComponent";

export const unityListFiles = () => {
  (window as any)["list_files"] = async (sceneName: any) => {
    (window as any).list_and_call("files/" + sceneName, (_s: any) => {
      unityContext.send("NetworkManager", "OnListUpdated", _s);
    });
  };
};
